import * as ko from 'knockout'
import { MultiLegViewModel, MultiLegViewModelParams } from './MultiLegViewModel'
import template from './multi.leg.tpl.html'

if (!ko.components.isRegistered('multi-leg-bettype')) {
  ko.components.register('multi-leg-bettype', {
    viewModel: {
      createViewModel: (params: MultiLegViewModelParams) => {
        const viewModel = new MultiLegViewModel(params)
        return viewModel
      },
    },
    template,
  })
}
